import React, { FC, Fragment } from 'react';
import { makeStyles, IconButton, TableHead, TableBody, TableRow, TableCell, Table } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { TableCellEnd, TableCellMiddle, TableCellStart, TableRowCustom, TableRowCollapse } from 'components';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';

interface Props {
  product: ProductModel;
  isLoading: boolean;
  openCollapse: boolean;
  index: number;
  indexCollapse: number;
  loadingItem: boolean;
  checked: InvoiceReturnItemModel[];
  returnAdjust: number;
  returnNumber:
    | {
        InvoiceReturnItemAdditionalDamage: number;
        InvoiceReturnItemTotalDamage: number;
        InvoiceReturnItemTotalMerge: number;
        InvoiceReturnItemTotalReturned: number;
        InvoiceReturnItemTotalitem: number;
        returnNumber: string;
        returnDate: string;
        typeReturn?: string;
        returnSalesDamage?: number;
        penampunganReturn?: number;
        returnSupplier?: number;
      }[]
    | null;
  handleChecked: (item: InvoiceReturnItemModel) => void;
  handleOpenCollapse: React.MouseEventHandler;
}

const useStyles = makeStyles({
  tableCell: {
    width: 100
  },
  tableCellAction: {
    width: 30
  },
  tableCollapse: {
    width: '100%'
  },
  cellCollapse: {
    border: 'none'
  }
});

const BodyRow: FC<Props> = props => {
  const classes = useStyles();
  const { product, isLoading, openCollapse, indexCollapse, index, loadingItem, returnNumber, returnAdjust, handleOpenCollapse } = props;
  const totalMasuk = returnNumber
    ? returnNumber.reduce(
        (acc, row) => acc + ((row.InvoiceReturnItemTotalReturned || row.InvoiceReturnItemTotalDamage) ? row.InvoiceReturnItemTotalitem : 0),
        0
      )
    : 0;
  const totalPenampungan = returnNumber ? returnNumber.reduce((acc, row) => acc + (row.penampunganReturn || 0), 0) : 0;

  return (
    <Fragment>
      <TableRowCustom>
        <TableCellStart>
          {isLoading ? (
            <Skeleton variant='text' width={60} height={25} />
          ) : (
            <IconButton aria-label='expand row' size='small' onClick={handleOpenCollapse}>
              {openCollapse && index === indexCollapse ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          )}
        </TableCellStart>
        <TableCellMiddle>{isLoading ? <Skeleton variant='text' width={100} height={25} /> : product.productName || '-'}</TableCellMiddle>
        <TableCellMiddle className={classes.tableCell} align='center'>
          {isLoading ? <Skeleton variant='text' width={100} height={25} /> : product.Category!.name || '-'}
        </TableCellMiddle>
        <TableCellMiddle>{isLoading ? <Skeleton variant='text' width={60} height={25} /> : '-'}</TableCellMiddle>
        <TableCellMiddle align='center' className={classes.tableCell}>
          {isLoading ? <Skeleton variant='text' width={100} height={25} /> : `${product.totalDamage || 0} ${product.typeUnit}`}
        </TableCellMiddle>
        <TableCellMiddle align='center' className={classes.tableCell}>
          {isLoading ? <Skeleton variant='text' width={100} height={25} /> : `${product.totalDamageEdit || 0} ${product.typeUnit}`}
        </TableCellMiddle>
        <TableCellEnd align='center' className={classes.tableCell}>
          {isLoading ? <Skeleton variant='text' width={100} height={25} /> : `${product.productReturn || 0} ${product.typeUnit}`}
        </TableCellEnd>
      </TableRowCustom>

      <TableRowCollapse open={openCollapse && product.id === indexCollapse && !isLoading} colSpan={7}>
        <Table className={classes.tableCollapse} size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Nomor Invoice </TableCell>
              <TableCell align='center'>Tanggal Masuk</TableCell>
              <TableCell align='center'>Barang Rusak Return Penjualan</TableCell>
              <TableCell align='center'>Barang Rusak Gudang</TableCell>
              <TableCell align='center'>Barang rusak pada penampungan return</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loadingItem ? (
              <TableRow>
                <TableCell colSpan={4}>
                  <Skeleton variant='text' height={25} />
                </TableCell>
              </TableRow>
            ) : (
              returnNumber &&
              returnNumber.length > 0 &&
              returnNumber.map((value, index) => (
                <TableRow key={index}>
                  <TableCell>{value.returnNumber}</TableCell>
                  <TableCell align='center'>{value.returnDate}</TableCell>
                  <TableCell align='center'>
                    {value.InvoiceReturnItemTotalReturned || value.InvoiceReturnItemTotalDamage ? value.InvoiceReturnItemTotalitem : 0}
                  </TableCell>
                  <TableCell align='center'>-</TableCell>
                  <TableCell align='center'>{value.penampunganReturn || 0}</TableCell>
                </TableRow>
              ))
            )}
            {!loadingItem && returnNumber && returnNumber.length > 0 && (
              <TableRow>
                <TableCell style={{ fontWeight: 700 }}>TOTAL</TableCell>
                <TableCell align='center' style={{ fontWeight: 700 }}>
                  -
                </TableCell>
                <TableCell align='center' style={{ fontWeight: 700 }}>
                  {totalMasuk}
                </TableCell>
                <TableCell align='center' style={{ fontWeight: 700 }}>
                  {returnAdjust}
                </TableCell>
                <TableCell align='center' style={{ fontWeight: 700 }}>
                  {totalPenampungan}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableRowCollapse>
    </Fragment>
  );
};

export default BodyRow;
